var exports = {
  "D": "x234b8571--c7ee30--title",
};

module.exports = exports;
